import React from 'react';
import CreateWorkspaceModal from "layouts/dashboard/components/CreateWorkspaceModal";

const RequireWorkspace = ({ hasWorkspace, loading, user, initialLoadComplete, children }) => {
    if ((loading || hasWorkspace === null) && !initialLoadComplete) {
        return null; // Don't render until we know the status
    }

    if (hasWorkspace === false) {
        return <CreateWorkspaceModal open={true} user={user} />;
    }

    return children;
};

export default RequireWorkspace;
